import { FormControl } from "@atoms"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Drawer, DrawerProps } from "antd"
import TextArea from "antd/es/input/TextArea"
import RatingEmojis from "components/rating-emojis"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { object, string } from "yup"
import { IPresence } from "./types"
import { useCreateFeedback } from "./queries"
import { useEventId } from ".."
import { useEffect } from "react"

interface Props extends DrawerProps {
  onClose: () => void
  data?: IPresence
}

const FeedbackDrawer: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const { mutate, isLoading } = useCreateFeedback(eventId!, props.data?.id!)

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useFeedbackForm({
    feedback: props.data?.feedback,
    emoji: props.data?.emoji!,
  })

  const onSubmit = (data: IFeedbackForm) => {
    mutate(data, {
      onSuccess() {
        props.onClose()
        reset()
      },
    })
  }

  useEffect(() => {
    reset({
      feedback: props.data?.feedback,
      emoji: props.data?.emoji!,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])
  return (
    <Drawer title={t("labels.feedback")} {...props}>
      <form>
        <FormControl>
          <Controller
            name="emoji"
            control={control}
            render={({ field }) => {
              return (
                <RatingEmojis
                  value={field.value}
                  onClick={(rate) => field.onChange(rate)}
                />
              )
            }}
          />
          {errors.emoji && (
            <FormControl.HelperText>
              {errors.emoji.message}
            </FormControl.HelperText>
          )}
        </FormControl>
        <FormControl>
          <Controller
            name="feedback"
            control={control}
            render={({ field }) => (
              <TextArea
                placeholder={t("labels.feedback")}
                rows={4}
                {...field}
              />
            )}
          />
        </FormControl>
        <Button
          loading={isLoading}
          type="primary"
          onClick={handleSubmit(onSubmit)}
        >
          {t("global.save")}
        </Button>
      </form>
    </Drawer>
  )
}

export default FeedbackDrawer

export interface IFeedbackForm {
  feedback?: string
  emoji: "very bad" | "bad" | "neutral" | "good" | "very good" | null
}

const useFeedbackForm = (defaultValues: IFeedbackForm) => {
  const schema = object().shape({
    feedback: string().nullable(),
    emoji: string().required(),
  })
  return useForm({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
